import { FLUXO_EVENTOS } from "src/utils/api-routes"
import { ServiceRequest } from "src/utils/service-request"


class EventosFluxoService {
    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    async getFluxoEventos(cetip, versaoDocumento) {
        const params = new URLSearchParams({ CETIP: cetip })

        const versaoInformada = versaoDocumento !== undefined && versaoDocumento !== null && versaoDocumento !== ""

        if (versaoInformada) {
            params.append("VersaoDocumento", versaoDocumento)
        }

        return this.serviceRequest.get(`${FLUXO_EVENTOS}?${params.toString()}`)
    }
}

export default EventosFluxoService